module.exports = __webpack_public_path__ + "static/MainServicesVideo-fc336140f6db904641425092ff309339.mp4";